module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Round and Round")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("By Andrew Grey")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoInd"
  }, [_vm._v("Sequel to "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Backwards")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoInd"
  }, [_vm._v("Bronco's Boys: Book Four")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When it comes to love, Kevin Foster can’t seem to win. Some consider him a hero, but dousing an arsonist’s attempt to burn Bronco’s to the ground puts Kevin on the vengeful criminal’s radar. Afterward, the arsonist fixates on Kevin, determined to burn away every part of Kevin’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Coming to Kevin’s rescue more than once, and in more ways than one, is “MacDreamy Hotness”—firefighter Angus MacTavish. Not only is Angus smitten at first sight, he learns Kevin’s nickname for him, intriguing him further.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When Angus discovers Kevin is the arsonist’s target, he takes it upon himself to protect him at any cost. Soon Kevin works his way into a heart Angus thought he’d closed off for good. Things heat up between them, but the arsonist has no intention of letting Kevin finally find happiness. Hopefully Angus and Kevin can stop him before he reduces everything Kevin values to ash—including the love igniting between him and Angus.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0